import React from 'react'
import ReactModal from 'react-modal'

const Modal = ({ 
  className,
  children, 
  isOpen, 
  onConfirm,
  toggleModal,
  type,
  withOpen 
}) => {
  const { container, body } = className

  const renderFooter = () => {
    if(type === 'livechat'){
      return(
        <div className='button-container'>
          {withOpen && <button
            className='eblue-button open-chat-window'
            onClick={toggleModal}>
            Open LiveChat
          </button>}
          <hr/>
          <button
            className='btn btn-danger-tertiary close-modal'
            onClick={toggleModal}>
            Close
          </button>
        </div>
      )
    }else if(type === 'empty'){
      return ''
    }else if(type === 'cancel'){
      return(
        <div className="button-container">
          <hr />
          <button
            className='btn btn-confirm close-modal'
            onClick={toggleModal}>
            CANCEL
          </button>
        </div>
      )
    }
    else{
      return(
        <div className="button-container">
          <hr />
          <button
            className='btn btn-confirm close-modal'
            onClick={toggleModal}>
            CANCEL
          </button>
          <button
            className='btn btn-danger close-modal'
            onClick={onConfirm}>
            CONFIRM
          </button>
        </div>
      )
    }
  }

  return (
    <ReactModal
      className={container || 'react-modal generic info-modal confirm'}
      onRequestClose={toggleModal}
      isOpen={isOpen}
      appElement={document.querySelector('#root')}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
      <div className={body || 'generic-info-modal-header'}>
        <i className='fa fa-times-thin fa-2x' onClick={toggleModal}></i>
      </div>
      {children}
      {renderFooter()}
    </ReactModal>
  )
}

export default Modal
